export default "__VITE_ASSET__ChfvpWF2__"